import { MonitoringPreferencesTypes } from './types';

interface GetMonitoringPreferencesParams {
  companyId?: number;
}

export const getMonitoringPreferences = (companyId: number | null = null) => {
  const params: GetMonitoringPreferencesParams = {};
  if (companyId) params.companyId = companyId;
  return {
    types: [
      MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_REQUEST,
      MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_SUCCESS,
      MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_FAILURE,
    ],
    promise: (client: any) =>
      client.get('/boletim_web/minha_conta/monitoring_preferences', { params }),
  };
};

export const updateMonitoringPreferences = (
  monitoring_preference_id: number,
  notification_type: string,
  values: { value?: string; priority?: string } = {},
) => ({
  types: [
    MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_REQUEST,
    MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_SUCCESS,
    MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_FAILURE,
  ],
  monitoring_preference_id,
  promise: (client: any) =>
    client.patch(`/boletim_web/minha_conta/monitoring_preferences/${monitoring_preference_id}`, {
      id: monitoring_preference_id,
      notification_type,
      ...values,
    }),
});
